import { FilterGroup } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '../types';
import { getConditionalStatusFilter } from './conditionalStatus/conditionalStatus';
import { getUniversityFilter } from './university/university';
import { getCourseConditionalStatusFilter } from './courseConditionalStatus/courseConditionalStatus';
import { notEmpty } from '@/utilities/helpers';
import { getCourseFilter } from './course/course';
import { getFacultyFilter } from './faculty/faculty';

export const getOffersGroupFilters = (props: IGetFilterGroupsProps): FilterGroup => {
  return {
    name: 'OFFERS',
    filters: [
      getUniversityFilter(props),
      getFacultyFilter(props),
      getCourseFilter(props),
      getConditionalStatusFilter(props),
      getCourseConditionalStatusFilter(props),
    ].filter(notEmpty),
  };
};
